module.exports = __webpack_public_path__ + "img/vehicleviola.af41b61a.png";